"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"

const KEY = "cookie-consent"

export default function CookieConsent() {
  const pathname = usePathname()
  const [open, setOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const status = localStorage.getItem(KEY)
    const isPrivacy = pathname.includes("privacy")

    if (isPrivacy || status === "accepted") {
      setOpen(false)
      document.body.style.overflow = ""
      return
    }

    if (!status) {
      setOpen(true)
      document.body.style.overflow = "hidden"
    }
  }, [pathname])

  useEffect(() => {
    if (!open) return

    const check = () => setIsMobile(window.innerWidth < 640)
    check()

    window.addEventListener("resize", check)

    return () => window.removeEventListener("resize", check)
  }, [open])

  const close = () => {
    setOpen(false)
    document.body.style.overflow = ""
  }

  const accept = () => {
    localStorage.setItem(KEY, "accepted")
    close()
    window.location.reload()
  }

  const reject = () => {
    localStorage.setItem(KEY, "rejected")
    close()
  }

  if (!open) return null

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999999,
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.2)",
        }}
      />

      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "12px" : 0,
          left: isMobile ? "12px" : 0,
          right: isMobile ? "12px" : 0,
          background: "#fff",
          padding: isMobile ? "20px" : "40px 75px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "24px" : "56px",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "flex-end",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <p
            style={{
              fontSize: "28px",
              fontWeight: "700",
              color: "#333",
              margin: 0,
            }}
          >
            Cookie Settings
          </p>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "400",
              color: "#333",
              margin: 0,
            }}
          >
            SnapThePrice website use cookies. By continuing to use our website,
            you accept that cookies may be stored on your device, as outlined in
            our{" "}
            <Link
              href="/privacy"
              style={{
                color: "rgb(3, 169, 250)",
                textDecorationLine: "underline",
              }}
            >
              Cookie Policy
            </Link>
            .
          </p>
        </div>

        <div
          style={{
            flexShrink: 0,
            display: "flex",
            gap: "12px",
          }}
        >
          <button
            onClick={accept}
            style={{
              padding: "12px 24px",
              border: "none",
              background: "#000",
              color: "#fff",
              cursor: "pointer",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Accept All
          </button>

          <button
            onClick={reject}
            style={{
              padding: "12px 24px",
              border: "none",
              background: "#eee",
              cursor: "pointer",
              fontWeight: "700",
              fontSize: "14px",
            }}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
